import React, { useState, useEffect } from 'react';
import { Applicants } from './components/Applicants';
import { Ethnicity } from './components/Ethnicity';
import { Footer } from './components/Footer';
import { Gender } from './components/Gender';
import { GraduatingClass } from './components/GraduatingClass';
import { Hero } from './components/Hero';
import { TopMajor } from './components/TopMajor';
import { TopSchools } from './components/TopSchools';
import { YearBanner } from './components/YearBanner';
import { YearSelector } from './components/YearSelector';
import { data as hackathonData } from './utils/data';
import { HackathonData } from './utils/data_types';

const App: React.FC = () => {
  const [data, setData] = useState<HackathonData>(hackathonData[2020]);

  useEffect(() => {
    console.log(data);
  }, [data]);

  return (
    <>
      <Hero />
      <YearSelector setData={setData} />
      <YearBanner year={data.year.toString()} />
      <Applicants applicantData={data.applicants} />
      <Gender genderData={data.gender} />
      {data.year !== 2015 && data.ethnicity && <Ethnicity ethnicityData={data.ethnicity} />}
      <GraduatingClass classData={data.graduatingClass} />
      <TopMajor majorData={data.topMajors} />
      <TopSchools schoolData={data.topSchools} />
      <Footer />
    </>
  );
};

export default App;
